import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { Filter } from "../interfaces/filter.interface";
import { PaymentVoucherMST } from "../interfaces/payment-voucher.interface";



@Injectable({
  providedIn: 'root',
})
export class PaymentVoucherService {
  private baseUrl = environment.apiBaseUrl;

  constructor(private http: HttpClient, private router: Router) {}

  getVoucher(id: number): Observable<any> {
    return this.http.get(`${this.baseUrl + '/PaymentVoucher'}` + '/' + id);
  }

  listVouchers(
    PageNumber = 1,
    PageSize = 10,
    Term = '',
    filters?: Filter[]
  ): Observable<any> {
    const params = {
      term: Term,
      advancedFilter: filters,
      pageNumber: PageNumber,
      pageSize: PageSize,
    };
    return this.http.post(`${this.baseUrl + '/PaymentVoucher/list'}`, params);
  }
  

  createVoucher(data: PaymentVoucherMST): Observable<any> {
    return this.http.post(`${this.baseUrl + '/PaymentVoucher'}`, data);
  }

  /**
   * Create voucher with FormData (supports file attachments)
   */
  createVoucherWithFormData(formData: FormData): Observable<any> {
    return this.http.post(`${this.baseUrl + '/PaymentVoucher'}`, formData);
  }

  updateVoucher(id: number, data: PaymentVoucherMST): Observable<any> {
    return this.http.put(`${this.baseUrl + '/PaymentVoucher'}/${id}`, data);
  }

  /**
   * Update voucher with FormData (supports file attachments)
   */
  updateVoucherWithFormData(id: number, formData: FormData): Observable<any> {
    return this.http.put(`${this.baseUrl + '/PaymentVoucher'}/${id}`, formData);
  }

  approveVoucher(id: number): Observable<any> {
    return this.http.post(`${this.baseUrl + '/PaymentVoucher'}/${id}/approve`, {});
  }

  deleteVoucher(id: number): Observable<any> {
    return this.http.delete(`${this.baseUrl + '/PaymentVoucher'}` + '/' + id);
  }

  getJournals(voucherHeaderId: any): Observable<any> {
    return this.http.post(`${this.baseUrl + '/Journal/ByReference'}`, voucherHeaderId);
  }
 // https://dev.api.getyusr.com/api/v1/Journal/ByReference
}
